module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/logo_amex.2dc1fd72.svg";